import * as Actions from "store/actions/app/subsorts.actions"

const initialState = {
  saving_subsort: false,
  saved_subsort: false,

  updating_subsort: false,
  updated_subsort: false,

  deleting_subsort: false,
  deleted_subsort: false,
}

const subsortsReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SAVE_SUBSORT: {
      return {
        ...state,
        saving_subsort: action.payload.saving ?? false,
        saved_subsort: action.payload.saved ?? false,
      }
    }
    case Actions.TOGGLE_SUBSORT_STATUS: {
      return {
        ...state,
        updating_subsort: action.payload.updating ?? false,
        updated_subsort: action.payload.updated ?? false,
      }
    }
    case Actions.DELETE_SUBSORT: {
      return {
        ...state,
        deleting_subsort: action.payload.deleting ?? false,
        deleted_subsort: action.payload.deleted ?? false,
      }
    }
    default: {
      return state
    }
  }
}
export default subsortsReducer
